import styled from "styled-components";
import { includeStyledSystem, sx } from "../util/styledSystem";
export const Flex = styled.div `
  box-sizing: border-box;
  min-width: 0;
  display: flex;
  ${includeStyledSystem()}
  ${sx}
`;
